import { useCreateOrUpdateMultipleSampleInExhibition } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FormLayoutElement } from "@/config/forms/general";
import { MultipleSampleInExhibition } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const MultiplesampleInExhibitionDrawer = ({
  fields,
  data,
  queryId,
  type,
  open,
  onOpenChange,
}: {
  fields: FormLayoutElement[] | undefined;
  data: MultipleSampleInExhibition;
  queryId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const schema = z.object({
    multiplesampleDansExpositionsDescriptionNumeroCatalogue: z
      .string()
      .optional(),
    multiplesampleDansExpositionsNotes: z.string().optional(),
    exhibition: z.object({
      expositionsDescriptionNumeroExpo: z.string(),
      expositionsDescriptionResume: z.string(),
    }),
  });

  const { mutate: createOrUpdateMultipleSampleInExhibition } =
    useCreateOrUpdateMultipleSampleInExhibition(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      exhibition: data.exhibition,
      multiplesampleDansExpositionsDescriptionNumeroCatalogue:
        data.multiplesampleDansExpositionsDescriptionNumeroCatalogue,
      multiplesampleDansExpositionsNotes:
        data.multiplesampleDansExpositionsNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateMultipleSampleInExhibition({
      id: data.id ?? "",
      multiplesampleId: data.multiplesample.id,
      exhibitionId: data.exhibition.id,
      multiplesampleDansExpositionsDescriptionNumeroCatalogue:
        formData.multiplesampleDansExpositionsDescriptionNumeroCatalogue,
      multiplesampleDansExpositionsNotes:
        formData.multiplesampleDansExpositionsNotes,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
      previewImage={{
        attachments: data.multiplesample.attachments ?? [],
        type: "multiplesample",
        alt:
          data.multiplesample
            .exemplaireDansEstampesMultiplesDescriptionNumeroEnregistrement,
      }}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default MultiplesampleInExhibitionDrawer;
